import { RemansoFigure } from "@/components/Brand";

export const OfflineScreen = () => (
  <main className="min-h-screen bg-papel flex items-center justify-center px-5 py-6" data-testid="offline-screen">
    <div className="max-w-[440px] w-full bg-hoja border border-linea rounded-[24px] px-7 py-9">
      <RemansoFigure estado="espera" height={96} testId="offline-remanso" />
      <h1 className="font-serif text-4xl text-tinta mt-6 mb-2">Sin conexión</h1>
      <p className="text-base text-sec leading-relaxed">Tu hoja te espera aquí. Cuando vuelva la conexión, seguimos.</p>
      <p className="mt-7 pt-5 border-t border-linea text-[14px] text-sec leading-relaxed" data-testid="offline-crisis-note">
        Si estás pensando en hacerte daño, llama a la Línea de la Vida al{" "}
        <a href="tel:8009112000" className="font-semibold text-tinta underline-offset-2 hover:underline">800 911 2000</a> (24 horas, gratis) o al{" "}
        <a href="tel:911" className="font-semibold text-tinta underline-offset-2 hover:underline">911</a>.
      </p>
    </div>
  </main>
);
